Vue.component('spark-notifications', {
    props: ['notifications', 'loadingNotifications'],

    computed: {
        /**
         * Get the active notifications or announcements.
         */
        activeNotifications() {
            if (!this.notifications) {
                return []
            }
            return this.notifications
        },

        /**
         * Determine if the user has any notifications.
         */
        hasNotifications() {
            return this.notifications && this.notifications.length > 0
        },
    },
})
